import Api from "@/services/api";
import {
	LOAD_RULESBYAMOUNT,
	CREATE_RULESBYAMOUNT,
	EDIT_RULESBYAMOUNT,
	REMOVE_RULESBYAMOUNT,
	REMOVE_RULESBYAMOUNTS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import {
	SET_RULESBYAMOUNT,
	ADD_RULESBYAMOUNT,
	UPDATE_RULESBYAMOUNT,
	DELETE_RULESBYAMOUNT,
} from "@/store/_mutationtypes";

const state = {
	ruleslist: [],
};

const actions = {
	[LOAD_RULESBYAMOUNT]({ commit }) {
		Api.get("/ruleamount").then((response) => {
			let vRulesbyamount = response.data;
			commit(SET_RULESBYAMOUNT, vRulesbyamount);
		});
	},
	[CREATE_RULESBYAMOUNT]({ commit, dispatch }, { item }) {
		return Api.post("/ruleamount", {
			name: item.name,
			responsCodeId: item.responsCodeId,
			responsCodeName: item.responsCodeName,
			amount: item.amount,
		}).then((response) => {
			let vRulesbyamount = response.data;
			commit(ADD_RULESBYAMOUNT, vRulesbyamount);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RULESBYAMOUNT added successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[EDIT_RULESBYAMOUNT]({ commit, dispatch }, { item }) {
		return Api.put(`/ruleamount/${item.id}`, item).then((response) => {
			let vRulesbyamount = response.data;
			commit(UPDATE_RULESBYAMOUNT, vRulesbyamount);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RULESBYAMOUNT updaded successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_RULESBYAMOUNT]({ commit, dispatch }, { id }) {
		Api.delete(`/ruleamount/${id}`).then(() => {
			commit(DELETE_RULESBYAMOUNT, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "RULESBYAMOUNT deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_RULESBYAMOUNTS]({ commit, dispatch }, { ids }) {
		ids.forEach((id) => {
			Api.delete(`/ruleamount/${id}`).then(() => {
				commit(DELETE_RULESBYAMOUNT, id);
			});
			dispatch(
				`alert/${ADD_ALERT}`,
				{
					message: `Successfully deleted ${ids.length} RULESBYAMOUNTS`,
					color: "success",
				},
				{ root: true }
			);
		});
	},
};

const mutations = {
	[SET_RULESBYAMOUNT](state, rulesbyamount) {
		state.ruleslist = rulesbyamount;
	},
	[ADD_RULESBYAMOUNT](state, rulesbyamount) {
		state.ruleslist.push(rulesbyamount);
	},
	[UPDATE_RULESBYAMOUNT](state, item) {
		let ruleUpdated = state.ruleslist.find((h) => h.id == item.id);
		ruleUpdated.name = item.name;
		ruleUpdated.responsCodeId = item.responsCodeId;
		ruleUpdated.responsCodeName = item.responsCodeName;
		ruleUpdated.amount = item.amount;
	},
	[DELETE_RULESBYAMOUNT](state, id) {
		state.ruleslist = state.ruleslist.filter((h) => h.id != id);
	},
};

export const rulesbyamount = {
	namespaced: true,
	state,
	actions,
	mutations,
};
